import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '@src/app/core/services/user.service';
import { LoadingSpinnerService } from '@src/app/shared/services/loading-spinner.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  email: string = ''; // default for testing
  password: string = ''; // default for testing
  showPassword: boolean = false; // to toggle password visibility
  returnUrl: string = '/';
  errors: string[] = [];

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
    private readonly loadingSpinnerService: LoadingSpinnerService
  ) {
    // Subscribe to queryParams to get the returnUrl
    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnUrl'] || '';
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  login() {
    
    this.loadingSpinnerService.show();
    this.userService.login(this.email, this.password).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
          this.router.navigateByUrl(returnUrl);
          // check that the returnUrl isn't this address
          // if (this.returnUrl === this.router.url || this.returnUrl.includes('login')) {
          //   this.returnUrl = '';
          // }
          // this.router.navigateByUrl(this.returnUrl);
        } else {
          this.errors = response.errors;
        }
      },
      error: (error) => {
        console.error('Login failed:', error);
      },
      complete: () => {
        this.loadingSpinnerService.hide();
      },
    });

  }
}
